import * as React from "react"
import { useEffect } from "react"
import { batch } from "@preact/signals-react"

import { CommonFilters } from "@components"
import {COMMON_FILTER_KEYS, BANNERS_ROUTES, BACKEND_APIS} from "@constants"
import { useAppDefaultFilters } from "@hooks"
import { PAGE_CATEGORY, PAGE_PRODUCT_TYPE } from "@constants"
import { isLoadingCommonFilters, isSystemBusy } from "@signals"
import {isBannersPercentageEmpty} from "./@signals";


const OPTIONS_PAGE_CATEGORY_REMOVE = [
    PAGE_CATEGORY.EDITORIAL, PAGE_CATEGORY.PROMOTION,
    PAGE_CATEGORY.OTHERS, PAGE_CATEGORY.BRAND_LOGO
]

const OPTIONS_PAGE_PRODUCT_TYPE_REMOVE = [
    PAGE_PRODUCT_TYPE.EDITORIAL_CONTENT, PAGE_PRODUCT_TYPE.NON_FRAGRANCES,
]


export default function BannersPercentageFilters() {

    const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(BANNERS_ROUTES.PERCENTAGE_ID, BANNERS_ROUTES.ACCESS_KEY)

    useEffect(() => {
        callUserDefaultFilters()
    }, [])

    return <CommonFilters
        components={{
            favFilters: true, site: true, company: true,
            brandAsync: true, pageCategory: true, pageProductType: true, sectionCategory: true,
            resourceType: true, bannersTags: true, favFiltersOnlyLine: true,
        }}
        compProps={{
            favFilters: {
                grid: { md: 3 },
                allowedFilters: [
                    COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
                    COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU, COMMON_FILTER_KEYS.SECTION_CATEGORY, COMMON_FILTER_KEYS.PAGE_CATEGORY,
                    COMMON_FILTER_KEYS.PAGE_PRODUCT_TYPE, COMMON_FILTER_KEYS.RESOURCE_TYPE, COMMON_FILTER_KEYS.TAGS, COMMON_FILTER_KEYS.DEVICE_TYPE,
                    COMMON_FILTER_KEYS.COMPANY
                ],
                dashboardKey: BANNERS_ROUTES.TOP_BANNERS_ID
            },
            site: { urlAjax: `${BACKEND_APIS.MASTER_DATA}/site/wrapped/new-options`, grid: { md: 4, xs: 4 } },
            brandAsync: { grid: { md: 4, xs: 4 } },
            company: { urlAjax: `${BACKEND_APIS.MASTER_DATA}/company/wrapped/new-options`, grid: { md: 4, xs: 4 } },
            pageCategory: { grid: { md: 6, xs: 6 }, excludeOptions: OPTIONS_PAGE_CATEGORY_REMOVE, label: 'Mono/Multi Brand', placeholder: 'All' },
            pageProductType: { grid: { md: 4, xs: 4 }, excludeOptions: OPTIONS_PAGE_PRODUCT_TYPE_REMOVE, label: 'Product Category' },
            resourceType: { grid: { md: 4, xs: 4 }, label: 'Image Type', placeholder: 'All images types' },
            bannersTags: { grid: { md: 6, xs: 6 }, label: 'All tags' },
            sectionCategory: { grid: { md: 4, xs: 4 }, label: 'Section Category' },
        }}
        onSubmit={() => { batch(() => {
            isBannersPercentageEmpty.value = false
            isLoadingCommonFilters.value = true
            isSystemBusy.value = false
        })}}
        defaultValues={userFilters}
        isLoadingDefaultFilters={isLoadingDefaultFilters}
    />
}
